import React from "react";
import * as XLSX from "xlsx";

const DownloadExcelFromTable = ({ tableRef, fileName = "table_data.xlsx" }) => {
  const handleDownload = () => {
    try {
      if (!tableRef?.current) {
        alert("Table reference not found!");
        return;
      }

      const originalTable = tableRef.current;
      const clonedTable = originalTable.cloneNode(true);

      // 🔥 FIX SELECT (sync original → clone)
      const originalSelects = originalTable.querySelectorAll("select");
      const clonedSelects = clonedTable.querySelectorAll("select");

      originalSelects.forEach((select, i) => {
        const value = select.value; // REAL selected value
        const td = clonedSelects[i]?.closest("td");

        if (td) td.textContent = value || "";
      });

      // 🔥 FIX INPUT (sync original → clone)
      const originalInputs = originalTable.querySelectorAll("input");
      const clonedInputs = clonedTable.querySelectorAll("input");

      originalInputs.forEach((input, i) => {
        const td = clonedInputs[i]?.closest("td");
        if (!td) return;

        if (input.type === "checkbox") {
          td.textContent = input.checked ? "Yes" : "No";
        } else {
          td.textContent = input.value || "";
        }
      });

      // Convert to sheet
      const worksheet = XLSX.utils.table_to_sheet(clonedTable);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Export
      const buffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`;

      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert("Excel export failed");
    }
  };

  return (
    <div className="d-flex justify-content-end">
      <button
        type="button"
        onClick={handleDownload}
        className="btn btn-sm btn-outline-success"
      >
        Download Excel
      </button>
    </div>
  );
};

export default DownloadExcelFromTable;
